import { IconComponentProps } from './index'

const NavigationCreate = ({ width = 24, height = 24, customClass = '' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={`strokefill ${customClass}`}>
  <path d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z' stroke='white' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/>
  <path d='M12 8V16' stroke='white' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/>
  <path d='M8 12H16' stroke='white' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/>
</svg>

export default NavigationCreate